import React, { useState } from "react";
import "./ConnectForm.css";
import Heading from "../../../utls/Heading";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PhoneInput } from "react-international-phone";
const ConnectForm = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    FName: "",
    LastName: "",
    Email: "",
    Company: "",
    Sales: "",
    Message: "",
    Number: "",
    Location: "",
  });

  const resetForm = () => {
    setFormData({
      FName: "",
      LastName: "",
      Email: "",
      Company: "",
      Sales: "",
      Message: "",
      Number: "",
      Location: "",
    });
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handlePhoneChange = (value) => {
    setFormData({
      ...formData,
      Number: value, // Using 'Number' to match your existing formData structure
    });
  };

  const validateForm = () => {
    const errors = [];

    // Required field validation
    if (!formData.FName.trim()) errors.push("First Name is required");
    if (!formData.LastName.trim()) errors.push("Last Name is required");
    if (!formData.Email.trim()) errors.push("Email is required");
    if (!formData.Company.trim()) errors.push("Company is required");
    if (!formData.Message.trim()) errors.push("Message is required");
    if (!formData.Number.trim()) errors.push("Phone Number is required");
    if (!formData.Location.trim()) errors.push("Location is required");

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (formData.Email.trim() && !emailRegex.test(formData.Email.trim())) {
      return ["Please Enter A Valid Email Address"];
    }

    // Phone number validation (basic check for minimum length)
    if (formData.Number && formData.Number.length < 10) {
      errors.push("Please Enter A Valid Phone Number");
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form before submission
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      validationErrors.forEach((error) => toast.error(error));
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        "https://blueberry-travel.com/api/APIUser/SubmitEnquiryBBT",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        await response.json();
        toast.success("Enquiry Submitted. Our Team Will Contact You Shortly.");
        resetForm();
      } else {
        toast.error("Failed To Submit The Form. Please Try Again Later.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An Error Occurred While Submitting The Form.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="connect-section d-md-block d-none">
        <h4 className="headings d-md-none d-block ms-3 mb-4">
          Connect With Us!
        </h4>
        <div className="container px-lg-5 w-100 position-relative">
          <div className="connect-bg">
            <div className="row">
              <div className="col-lg-3 col-md-12">
                <div className="left-side position-absolute top-0 start-0  text-white d-md-block d-none">
                  <p className="label-txt">TAKE YOUR FIRST STEP</p>
                  <Heading className="headings w-75 first-section position-relative zindex">
                    Connect with Us!
                  </Heading>
                </div>
              </div>
              <div className="col-lg-4 ">
                <div className="semicircle position-absolute"></div>
                <div className="connect-girl position-absolute"></div>
              </div>
              <div className="col-lg-6 col-md-12 ">
                <div className="box position-absolute p-lg-3 p-md-2 p-3 d-none d-md-block">
                  <form
                    className="ps-lg-4 pe-lg-4 ps-md-3 pe-md-3 connect-form"
                    onSubmit={handleSubmit}
                  >
                    <div className="name-section d-flex mt-xxl-3 mt-lg-1 mt-md-1 gap-2 mt-3">
                      <input
                        type="text"
                        name="FName"
                        placeholder="First Name"
                        className="form-control p-xxl-2 p-2"
                        value={formData.FName}
                        onChange={(e) =>
                          setFormData({ ...formData, FName: e.target.value })
                        }
                        required
                      />
                      <input
                        type="text"
                        name="LastName"
                        placeholder="Last Name"
                        className="form-control"
                        value={formData.LastName}
                        onChange={(e) =>
                          setFormData({ ...formData, LastName: e.target.value })
                        }
                        required
                      />
                    </div>
                    <input
                      type="email"
                      name="Email"
                      value={formData.Email}
                      className="mt-md-1 mt-xxl-2 mt-lg-2 mt-2 form-control p-xxl-2 p-2"
                      placeholder="Email"
                      onChange={(e) =>
                        setFormData({ ...formData, Email: e.target.value })
                      }
                      required
                    />

                    <div className=" d-flex  gap-2 mt-md-1 mt-lg-2 mt-xxl-2 mt-2">
                      <PhoneInput
                        country={"in"}
                        defaultCountry={"ae"}
                        value={formData.Number}
                        onChange={handlePhoneChange}
                        inputClassName="form-control"
                        containerClass="phone-input-container"
                        className="connect-phone-container"
                        inputProps={{
                          name: "Number",
                          required: true,
                          placeholder: "Phone Number",
                        }}
                        enableSearch={true}
                        preferredCountries={["ae", "in", "ng", "za", "ke"]}
                        required
                      />
                    </div>

                    <div className="companyname-section d-flex mt-md-0 mt-lg-0  mt-xxl-2 gap-2 mt-2">
                      <input
                        type="text"
                        name="Company"
                        placeholder="Company Name"
                        className="form-control p-xxl-2 p-2"
                        value={formData.Company}
                        onChange={(e) =>
                          setFormData({ ...formData, Company: e.target.value })
                        }
                        required
                      />
                      <input
                        type="text"
                        name="Location"
                        placeholder="Where are you located?"
                        className="form-control"
                        value={formData.Location}
                        onChange={(e) =>
                          setFormData({ ...formData, Location: e.target.value })
                        }
                        required
                      />
                    </div>
                    <textarea
                      name="Message"
                      placeholder="Message"
                      className="form-control mt-md-1 mt-lg-2 pb-md-3 mt-xxl-2 mt-2 pb-4"
                      rows="3"
                      value={formData.Message}
                      onChange={(e) =>
                        setFormData({ ...formData, Message: e.target.value })
                      }
                      required
                    ></textarea>
                    <div className="carouselCaption form-submit mt-lg-2 mt-xxl-3 ms-xxl-2  ">
                      <button
                        className="btn text-white fs-6 ps-4 pe-4 p-2 fw-bold"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Loading..." : "SUBMIT"}
                      </button>
                    </div>
                  </form>
                  {responseMessage && (
                    <p className="mt-3 text-center">{responseMessage}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999999999 }}
      />

      {/* ............................connect form for mobile...................... */}

      <div className="connect-section d-block d-md-none">
        <Heading className="headings first-section position-relative zindex ps-3">
          Connect With Us!
        </Heading>
        <div className="d-flex justify-content-center px-1">
          <div className="box p-3">
            <form
              className="ps-lg-4 pe-lg-4 ps-md-3 pe-md-3"
              onSubmit={handleSubmit}
            >
              <div className="name-section d-flex mt-xxl-3 mt-lg-2 mt-md-1 gap-2 mt-3">
                <input
                  type="text"
                  placeholder="First Name"
                  className="form-control p-xxl-2 p-2"
                  value={formData.FName}
                  onChange={(e) =>
                    setFormData({ ...formData, FName: e.target.value })
                  }
                  required
                />
                <input
                  type="text"
                  placeholder="Last Name"
                  className="form-control"
                  value={formData.LastName}
                  onChange={(e) =>
                    setFormData({ ...formData, LastName: e.target.value })
                  }
                  required
                />
              </div>
              <input
                type="email"
                placeholder="Email"
                className="mt-md-1 mt-xxl-3 mt-lg-2 mt-2 form-control p-xxl-2 p-2"
                value={formData.Email}
                onChange={(e) =>
                  setFormData({ ...formData, Email: e.target.value })
                }
                required
              />
              <div className=" d-flex  gap-2 mt-md-1 mt-lg-2 mt-xxl-2 mt-2">
                <PhoneInput
                  country={"in"}
                  defaultCountry={"ae"}
                  value={formData.Number}
                  onChange={handlePhoneChange}
                  inputClassName="form-control"
                  containerClass="phone-input-container"
                  className="connect-phone-container"
                  inputProps={{
                    name: "Number",
                    required: true,
                    placeholder: "Phone Number",
                  }}
                  enableSearch={true}
                  preferredCountries={["ae", "in", "ng", "za", "ke"]}
                  required
                />
              </div>

              <div className="companyname-section d-flex mt-md-1 mt-lg-2 mt-xxl-3  gap-2 mt-2">
                <input
                  type="text"
                  placeholder="Company Name"
                  className="form-control p-xxl-2 p-2"
                  value={formData.Company}
                  onChange={(e) =>
                    setFormData({ ...formData, Company: e.target.value })
                  }
                  required
                />
                <input
                  type="text"
                  placeholder="Where are you located ?"
                  className="form-control"
                  value={formData.Location}
                  onChange={(e) =>
                    setFormData({ ...formData, Location: e.target.value })
                  }
                />
              </div>
              <textarea
                placeholder="Message"
                className="form-control mt-md-1 mt-lg-2 pb-md-3 mt-xxl-3 mt-2 pb-4"
                value={formData.Message}
                onChange={(e) =>
                  setFormData({ ...formData, Message: e.target.value })
                }
                required
              ></textarea>
              <div className="carouselCaption mt-2">
                <button
                  className="btn text-white fs-6 ps-4 pe-4 p-2 fw-bold"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "SUBMIT"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectForm;
